import { render, staticRenderFns } from "./HrSalaryCalcGjj.vue?vue&type=template&id=1b6a5e80&scoped=true&"
import script from "./HrSalaryCalcGjj.vue?vue&type=script&lang=js&"
export * from "./HrSalaryCalcGjj.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a5e80",
  null
  
)

export default component.exports